<template>
  <div>
    <v-text-field v-if="control.hasMask"
                  :id="control.uniqueId"
                  type="text"
                  :class="controlFieldClass"
                  v-model="inputModel"
                  :name="control.name"
                  :placeholder="control.placeholderText"
                  :disabled="isDisabled"
                  @input="updateValue(inputModel)"
                  v-mask="control.mask"
                  dense
    />
    <v-text-field v-else
                  :id="control.uniqueId"
                  type="text"
                  :class="controlFieldClass"
                  v-model="inputModel"
                  :name="control.name"
                  :placeholder="control.placeholderText"
                  :disabled="isDisabled"
                  @input="updateValue(inputModel)"
                  dense
    />
  </div>
</template>

<script>
import {BaseControlSkeleton} from 'v-form-builder';
import {readUserProfile} from '@/store/main/getters';

export default {
  name: 'TextFieldControl',
  extends: BaseControlSkeleton,
  data: () => ({
    inputModel: null,
    isDisabled: false,
  }),
  async mounted() {
    const userProfile = readUserProfile(this.$store);

    if (this.control.disableByRoleSetting) {
      this.isDisabled =
          !(userProfile?.role?.settings?.permissions?.can_edit_control_field?.methods?.can_edit_control_field);
    } else if (this.control.isDisabled) {
      this.isDisabled = true;
    }

    if (this.value) {
      this.inputModel = this.value;
      this.updateValue(this.inputModel);
      return;
    }

    if (this.control.defaultValue || this.control.defaultValueKey) {
      const customData = userProfile.role?.settings?.custom_data;
      const institutionName = userProfile.institution?.name
      let customValue = ""

      if (institutionName) {
        customValue = institutionName
      } else if (customData && customData.length > 0) {
        customValue = customData.filter((item) => item.name === this.control.defaultValueKey)[0]?.value;
      }

      this.inputModel = customValue;
      this.updateValue(this.inputModel);
    }

    if (!this.value) {
      await Promise.all([
        await new Promise((resolve, reject) => setTimeout(() => resolve(), 500)),
        this.updateValue(this.value),
        this.inputModel = this.value,
      ]);
    }
  },
};
</script>

<style scoped>

</style>
